module.exports = __webpack_public_path__ + "img/组 22.d77aff94.png";